export enum PermanentCandidatesAlertsFilterEnum {
    // Allows to filter alerts for none
    None = 0,
    // Alerts that the start date is in the past so that the AMs can follow up
    IsStartDateTodayOrPast = 1
}
